import selectors from '../globals/selectors';
import page from '../helpers/page';
import mobileCatalogFilter from '../components/mobileCatalogFilter';
import promoCarousel from '../components/promoCarousel';
import categoryFilter from '../components/categoryFilter';
import accordion from '../components/accordion/index';
import axios from 'axios';

page(() => {
	mobileCatalogFilter();
	promoCarousel();
	categoryFilter();

	const accordionEls = document.querySelectorAll(
		selectors.accordionNew.element
	);
	accordionEls.forEach((el) => accordion(el, { isOpened: true }));

	const filterForm = document.querySelector('.catalog__filter-form');
	const subBtn = document.querySelector('.filter-from__btn--submit');
	subBtn.addEventListener('click', (e) => {
		e.preventDefault();
		filterForm.submit();
	});

	const itemsInCart = document.getElementById('items-in-cart');
	const addToCartBtns = document.querySelectorAll(selectors.catalog.addToCart);
	addToCartBtns.forEach((el) => {
		el.addEventListener('click', (e) => {
			const element = e.target;

			if (element.classList.contains('buy2')) return;

			const count = 1;
			const itemId = element.dataset.id;

			if (count === 0)
                count = 1;

            let parameters = new URLSearchParams();
            parameters.append('pid', itemId);
            parameters.append('col', count);
            axios({
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                url: '/basket/add',
                data: parameters
            }).then((data) => {
				if (data.error) alert(data.message);
				else {
                    element.style.display = 'none';
                    element.nextSibling.style.display = '';
                    axios.get('/basket/getstat').then((cartData) => {
						console.log(cartData);
                        itemsInCart.textContent = cartData.data.count;
                    })
					.catch((error) => {
						console.log('Error ' + error.message)
					});
                }
            })
			.catch((error) => {
				console.log('Error ' + error.message)
			});
		});
	});

	const selectorFirst = document.querySelectorAll('.content-top__left-dropdown--first .content-top__item');
	selectorFirst.forEach((item) => {
		item.addEventListener('click', () => {
			window.location.href = '/catalog/setperpage?per_page=' + item.dataset.value + '&back=' + window.location.href;
		});
	});

	const selectSort = document.querySelectorAll('.content-top__left-dropdown--last .content-top__item');
	selectSort.forEach((item) => {
		item.addEventListener('click', () => {
			window.location.href = '/catalog/setsort?order=' + item.dataset.value + '&back=' + window.location.href;
		});
	});
	const buttonList = document.querySelectorAll('.btn.cars__link.btn--insert-shadow'); 	
	const modalElement = document.querySelector('.modal');
	const modalClose = document.querySelector('.modal__header-close');
	const modal = document.querySelector('.modal');

	buttonList.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			e._isModalBtn = true;
			document.body.style.overflow = 'hidden';
			modal.classList.add('modal-is-active');
		});
	});

	modalClose.addEventListener('click', () => {
		modalElement.classList.remove('modal-is-active');
	});

	document.addEventListener('keydown', (evt) => {
		if(modalElement.classList.contains('modal-is-active')){
		  	if(evt.key ==='Escape') {
			modalElement.classList.remove('modal-is-active');
		}
		}
	})

	modalElement.addEventListener('click', (evt) => {
		if (evt.target === evt.currentTarget) {
			modalElement.classList.remove('modal-is-active');
		}
	})
});
